import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import CampaignCenterPage from './pages/CampaignCenterPage.vue';
import CampaignEditorPage from './pages/CampaignEditorPage.vue';
import CampaignDetailPage from './pages/CampaignDetailPage.vue';
import CampaignSettingsPage from './pages/CampaignSettingsPage.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.CAMPAIGNS,
  permissions: ['administrator'],
};
const channelProps = route => ({
  channel: route.params.channel,
  campaignId: route.params.campaignId,
});

// Pages mounted by the core campaigns router (routes/dashboard/campaigns/campaigns.routes.js) for
// /campaigns/sms and /campaigns/whatsapp.
export { CampaignCenterPage };

// Children of the core `campaigns` route (spread into its `children`), relative paths.
export const campaignCenterChildRoutes = [
  {
    path: 'settings',
    name: 'wasapi_campaign_settings',
    component: CampaignSettingsPage,
    meta,
  },
  {
    path: ':channel(whatsapp|sms)/new',
    name: 'wasapi_campaign_new',
    component: CampaignEditorPage,
    props: channelProps,
    meta,
  },
  {
    path: ':channel(whatsapp|sms)/:campaignId(\\d+)',
    name: 'wasapi_campaign_detail',
    component: CampaignDetailPage,
    props: channelProps,
    meta,
  },
  {
    path: ':channel(whatsapp|sms)/:campaignId(\\d+)/edit',
    name: 'wasapi_campaign_edit',
    component: CampaignEditorPage,
    props: channelProps,
    meta,
  },
];

// Legacy URLs of the former "Broadcasts" page under CRM → Campaign Center.
export const routes = [
  {
    path: frontendURL('accounts/:accountId/crm/campaigns'),
    name: 'wasapi_campaigns_index',
    redirect: to => ({
      name: 'campaigns_whatsapp_index',
      params: { accountId: to.params.accountId },
    }),
  },
  {
    path: frontendURL('accounts/:accountId/crm/campaigns/:campaignId'),
    name: 'wasapi_campaign_report',
    redirect: to => ({
      name: 'wasapi_campaign_detail',
      params: {
        accountId: to.params.accountId,
        channel: 'whatsapp',
        campaignId: to.params.campaignId,
      },
      query: { tab: 'report' },
    }),
  },
];
